import { Component, OnInit, OnDestroy } from '@angular/core';
import { BrokerAuditDeclarationService } from '../broker-audit-declaration.service';
import { WorkflowModel } from '../../../model/workflowModel';
import { BrokerAuditDataModel } from '../../../model/brokerAuditDataModel';
import { SubmitBrokerAuditDataRequestModel } from '../../../model/submitBrokerAuditDataRequestModel';
import { MessageModel } from '../../../model/models';
import { Router } from '@angular/router';
import { CurrentPageWatcherService } from '../../../shared/utils/CurrentPageWatcher';
import { SubmitBrokerAuditDataResponseModel } from '../../../model/submitBrokerAuditDataResponseModel';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-broker-audit-declaration-save-data',
  templateUrl: './broker-audit-declaration-save-data.component.html',
  styleUrls: ['./broker-audit-declaration-save-data.component.css']
})
export class BrokerAuditDeclarationSaveDataComponent implements OnInit, OnDestroy {
  
  workflow: WorkflowModel = new WorkflowModel();
  brokerAuditDataModel: BrokerAuditDataModel = new BrokerAuditDataModel();
  submitBrokerAuditDataRequestModel: SubmitBrokerAuditDataRequestModel = new SubmitBrokerAuditDataRequestModel();
  lastUpdated: Date;

  notifyBrokerAuditLastUpdatedSubscription = new Subscription();

  userMessages: Array<MessageModel> = [];

  constructor(private router: Router,
              private currentPageWatcher: CurrentPageWatcherService,
              private brokerAuditDeclarationService: BrokerAuditDeclarationService) { 

    if (this.brokerAuditDeclarationService.brokerAuditDataModel != undefined && this.brokerAuditDeclarationService.brokerAuditDataModel.LastUpdated != undefined && this.brokerAuditDeclarationService.brokerAuditDataModel.LastUpdated != null) {
      this.lastUpdated = this.brokerAuditDeclarationService.brokerAuditDataModel.LastUpdated;
    }

  }

  ngOnInit() {
   
  }

  saveBAD(){
    this.currentPageWatcher.clearUserMessage();
    this.brokerAuditDeclarationService.getNotifySaveData().emit(true);
  }

  ngOnDestroy(): void {
    this.notifyBrokerAuditLastUpdatedSubscription.unsubscribe();
    // this.currentPageWatcher.clearUserMessage();
  }
}



// WEBPACK FOOTER //
// ./src/app/broker/broker-audit-declaration/broker-audit-declaration-save-data/broker-audit-declaration-save-data.component.ts